import { Maybe, MediaImage, ImageFile, ImageFormat } from '@/@types/graphql'
import addProtocol from './addProtocol'

function imageFormat (formats: any[], key: string = 'xs'): any | undefined  {
  const image = formats.find((item) => item.name === key)
  if (!image) return
  return image.file
}

// function smallerImageUrl (image: Maybe<MediaImage> | undefined) {
//   if (!image) return null
//   const files = [image.file]
//   if (image.formats) files.push(...image.formats.map((format) => format.file))
//   const compareSize = (a: ImageFile, b: ImageFile) => a.size - b.size
//   files.sort(compareSize)
//   const url = files[0]?.url
//   if (url) return addProtocol(url)
//   return null
// }

function smallerImageUrl (image: Maybe<MediaImage> | undefined) {
  const minHeight = 300
  const minWidth = 400
  if (!image) return null
  const files = [image.file]
  if (image.formats) files.push(...image.formats.map((format) => format.file))
  // Trie les formats d'image par taille (du plus petit au plus grand)
  const sortedFiles = files.sort((a, b) => a.size - b.size) || []

  // Trouve le premier format qui respecte les contraintes de minHeight et minWidth
  const suitableFile = sortedFiles.find(
    (file) => file.height >= minHeight && file.width >= minWidth)

  // Retourne l'URL de l'image du format trouvé,
  // ou l'URL de l'image originale si aucun format ne respecte les contraintes
  const url = suitableFile ? suitableFile.url : image.file.url
  if (url) return addProtocol(url)
  return null
}

// function smallerImageFormatUrl (formats: Maybe<ImageFormat[]>) {
//   if (!formats) return
//   const files = formats.map((format) => format.file)
//   const compareSize = (a: ImageFile, b: ImageFile) => a.size - b.size
//   files.sort(compareSize)
//   const url = files[0]?.url
//   console.log(url)
//   if (url) return addProtocol(url)
//   return null
// }

function smallerImageFormatUrl (formats: Maybe<ImageFormat[]>) {
  const minHeight = 300
  const minWidth = 400
  if (!formats) return
  const files = formats.map((format) => format.file)
  const sortedFiles = files.sort((a, b) => a.size - b.size)
  // console.log(sortedFormats)
  // Trouve le premier format qui respecte les contraintes de minHeight et minWidth
  const suitableFile = sortedFiles.find(
    (file) => file.height >= minHeight && file.width >= minWidth)

  // console.log(suitableFormat)
  // Retourne l'URL de l'image du format trouvé,
  if (suitableFile) {
    const url = suitableFile.url
    if (url) return addProtocol(url)
  }

  // ou l'url du format le plus grand si aucun format ne respecte les contraintes
  const largestFile = sortedFiles[sortedFiles.length - 1]
  const url = largestFile.url
  if (url) return addProtocol(url)
  return null

  // ou l'URL de l'image originale si aucun format ne respecte les contraintes
  // const url = suitableFormat ? suitableFormat.file.url : sortedFormats[sortedFormats.length - 1]
  // if (url) return addProtocol(url)
  // return null
}

export {
  imageFormat,
  smallerImageUrl,
  smallerImageFormatUrl
}

export default {
  imageFormat,
  smallerImageUrl,
  smallerImageFormatUrl
}
